// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"2aacfb43","96":"eb15ea23","198":"2aacfb43","263":"dbbea010","522":"c40af1b2","952":"a4daaa52","975":"eb15ea23"}[chunkId] + ".chunk.css";
};